import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { backButton } from '@tma.js/sdk-react';

/**
 * Wires the native Telegram BackButton to React Router.
 * On the home route the button is hidden; elsewhere it pops the history.
 *
 * Mount once at the layout level (AppShell).
 */
export function useBackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!backButton.isMounted()) return;

    const isHome = location.pathname === '/';
    if (isHome) {
      backButton.hide();
      return;
    }
    backButton.show();
    const off = backButton.onClick(() => {
      navigate(-1);
    });
    return () => {
      off();
    };
  }, [location.pathname, navigate]);
}
